import { useEffect, useState } from "react";
import OffCanvasButton from "./OffCanvasButton";
import FilterOffCanvas from "./OffCanvasBody";
import SelectFilter from "./filter/SelectFilter";
import FilterTitle from "./filter/FilterTitle";
import FilterLocation from "./filter/FilterLocation";
import FilterChips from "./filter/FilterChips";
import RatingFilter from "./filter/RatingFilter";

import servicesData from "../../data/HealthCenterInfo/services.json";
import specilitiesData from "../../data/specialities.json";
import departmentsData from "../../data/HealthCenterInfo/departments.json";
import operatingHoursData from "../../data/HealthCenterInfo/operatingHours.json";
import lenguageData from "../../data/HealthCenterInfo/lenguages.json";
import insuranceData from "../../data/HealthCenterInfo/insurances.json";
import medicaidData from "../../data/HealthCenterInfo/medicaid.json";
import accesibilityData from "../../data/HealthCenterInfo/accessibilities.json";
import {getCoordinatesFromAddress} from "../../helpers/healthCenterHooks/geolocation";

const ShortOffCanvasButton = ({
                                  label, icon, title,
                                  searchTerm, // ✅ Agregar searchTerm
                                  selectedServices, setSelectedServices,
                                  selectedSpecialities, setSelectedSpecialities,
                                  selectedDepartments, setSelectedDepartments,
                                  selectedLanguages, setSelectedLanguages,
                                  selectedInsurance, setSelectedInsurance,
                                  selectedMedicaid, setSelectedMedicaid,
                                  selectedAccessibility, setSelectedAccessibility,
                                  selectedRating, setSelectedRating,
                                  selectedHours, setSelectedHours,
                                  centerType, setCenterType,
                                  selectedAwards, setSelectedAwards,
                                  selectedQualityAndAccreditation, setSelectedQualityAndAccreditation,
                                  location, setLocation,
                                  distance, setDistance,
                                  setUserCoords
                              }) => {
    const offcanvasId = "shortOffcanvas";

    const [tempServices, setTempServices] = useState([]);
    const [tempSpecialities, setTempSpecialities] = useState([]);
    const [tempDepartments, setTempDepartments] = useState([]);
    const [tempLanguages, setTempLanguages] = useState([]);
    const [tempInsurance, setTempInsurance] = useState([]);
    const [tempMedicaid, setTempMedicaid] = useState([]);
    const [tempAccessibility, setTempAccessibility] = useState([]);
    const [tempRating, setTempRating] = useState(null);
    const [tempHours, setTempHours] = useState([]);
    const [tempCenterType, setTempCenterType] = useState("Any");
    const [tempAwards, setTempAwards] = useState("Any");
    const [tempQuality, setTempQuality] = useState("Any");
    const [tempLocation, setTempLocation] = useState("");
    const [tempDistance, setTempDistance] = useState(0);

    useEffect(() => {
        setTempServices(selectedServices);
        setTempSpecialities(selectedSpecialities);
        setTempDepartments(selectedDepartments);
        setTempLanguages(selectedLanguages);
        setTempInsurance(selectedInsurance);
        setTempMedicaid(selectedMedicaid);
        setTempAccessibility(selectedAccessibility);
        setTempRating(selectedRating);
        setTempHours(selectedHours);
        setTempCenterType(centerType);
        setTempAwards(selectedAwards);
        setTempQuality(selectedQualityAndAccreditation);
        setTempLocation(location);
        setTempDistance(distance);
    }, [
        selectedServices, selectedSpecialities, selectedDepartments, selectedLanguages,
        selectedInsurance, selectedMedicaid, selectedAccessibility, selectedRating,
        selectedHours, centerType, selectedAwards, selectedQualityAndAccreditation,
        location, distance
    ]);

    // ✅ Incluir searchTerm en el cálculo
    const totalFilters =
        (searchTerm && searchTerm.trim() ? 1 : 0) + // ✅ Agregar searchTerm
        selectedServices.length +
        selectedSpecialities.length +
        selectedDepartments.length +
        selectedLanguages.length +
        selectedHours.length +
        (selectedAwards !== "Any" ? 1 : 0) +
        selectedInsurance.length +
        selectedMedicaid.length +
        selectedAccessibility.length +
        (selectedRating ? 1 : 0) +
        (centerType !== "Any" ? 1 : 0) +
        (selectedQualityAndAccreditation !== "Any" ? 1 : 0) +
        (location ? 1 : 0) +
        (distance !== 0 ? 1 : 0);

    const handleClear = () => {
        const emptyArr = [];
        setTempServices(emptyArr);
        setTempSpecialities(emptyArr);
        setTempDepartments(emptyArr);
        setTempHours(emptyArr);
        setTempLanguages(emptyArr);
        setTempInsurance(emptyArr);
        setTempMedicaid(emptyArr);
        setTempAccessibility(emptyArr);
        setTempRating(null);
        setTempCenterType("Any");
        setTempLocation("");
        setTempDistance(0);
        setTempQuality("Any");
        setTempAwards("Any");

        setSelectedServices(emptyArr);
        setSelectedSpecialities(emptyArr);
        setSelectedDepartments(emptyArr);
        setSelectedHours(emptyArr);
        setSelectedLanguages(emptyArr);
        setSelectedInsurance(emptyArr);
        setSelectedMedicaid(emptyArr);
        setSelectedAccessibility(emptyArr);
        setSelectedRating(null);
        setCenterType("Any");
        setLocation("");
        setDistance(0);
        setSelectedQualityAndAccreditation("Any");
        setSelectedAwards("Any");

        localStorage.removeItem("appliedHealthFilters");
    };

    const handleApply = async () => {
        setSelectedServices(tempServices);
        setSelectedSpecialities(tempSpecialities);
        setSelectedDepartments(tempDepartments);
        setSelectedHours(tempHours);
        setSelectedLanguages(tempLanguages);
        setSelectedInsurance(tempInsurance);
        setSelectedMedicaid(tempMedicaid);
        setSelectedAccessibility(tempAccessibility);
        setSelectedRating(tempRating);
        setCenterType(tempCenterType);
        setLocation(tempLocation);
        setDistance(tempDistance);
        setSelectedQualityAndAccreditation(tempQuality);
        setSelectedAwards(tempAwards);

        try {
            const coords = await getCoordinatesFromAddress(tempLocation);
            setUserCoords(coords);
        } catch (e) {
            console.error("Error al obtener coordenadas:", e);
            setUserCoords(null);
        }
        localStorage.setItem("appliedHealthFilters", JSON.stringify({
            selectedServices: tempServices,
            selectedSpecialities: tempSpecialities,
            selectedDepartments: tempDepartments,
            selectedLanguages: tempLanguages,
            selectedInsurance: tempInsurance,
            selectedMedicaid: tempMedicaid,
            selectedAccessibility: tempAccessibility,
            selectedRating: tempRating,
            selectedHours: tempHours,
            centerType: tempCenterType,
            selectedAwards: tempAwards,
            selectedQualityAndAccreditation: tempQuality,
            location: tempLocation,
            distance: tempDistance
        }));
    };

    return (
        <>
            <OffCanvasButton                
                activeCount={totalFilters}
                target={`#${offcanvasId}`}
            />

            <FilterOffCanvas
                id={offcanvasId}
                title={title}
                onApply={handleApply}
                onClear={handleClear}
                rightButton="Apply"
                leftButton="Clear"
                width="w-50"
            >
                <FilterTitle title="Basic Filters" />
                <SelectFilter
                    label="Center Type"
                    options={["Option 1", "Option 2", "Option 3", "Option 4", "Option 5"]}
                    value={tempCenterType}
                    onChange={(e) => setTempCenterType(e.target.value)}
                />

                <FilterLocation
                    location={tempLocation}
                    onLocationChange={(e) => setTempLocation(e.target.value)}
                    distance={tempDistance}
                    onDistanceChange={(e) => setTempDistance(Number(e.target.value))}
                />

                <FilterChips title="Services Offered" data={servicesData.services} selectedItems={tempServices} setSelectedItems={setTempServices} />
                <FilterChips title="Specialities" data={specilitiesData.specialities} selectedItems={tempSpecialities} setSelectedItems={setTempSpecialities} />
                <FilterChips title="Departments" data={departmentsData.departments} selectedItems={tempDepartments} setSelectedItems={setTempDepartments} />

                <FilterTitle title="Advanced Filters" />
                <FilterChips title="Operating Hours" data={operatingHoursData.operatingHours} selectedItems={tempHours} setSelectedItems={setTempHours} />
                <FilterChips title="Languages" data={lenguageData.languages} selectedItems={tempLanguages} setSelectedItems={setTempLanguages} />
                <FilterChips title="Insurance Accepted" data={insuranceData.insurances} selectedItems={tempInsurance} setSelectedItems={setTempInsurance} />
                <FilterChips title="Accepts Medicaid" data={medicaidData.medicaid} selectedItems={tempMedicaid} setSelectedItems={setTempMedicaid} />
                <FilterChips title="Accessibility" data={accesibilityData.accessibilities} selectedItems={tempAccessibility} setSelectedItems={setTempAccessibility} />

                <SelectFilter
                    label="Quality And Accreditation"
                    options={["Any", "ISO 9001 Certified", "JCI Accredited", "National Health Certification"]}
                    value={tempQuality}
                    onChange={(e) => setTempQuality(e.target.value)}
                />

                <SelectFilter
                    label="Awards and Recognition"
                    options={["Any", "Top Rated Clinic", "Patient Choice Award"]}
                    value={tempAwards}
                    onChange={(e) => setTempAwards(e.target.value)}
                />

                <RatingFilter title="Patient Rating" value={tempRating} onChange={setTempRating} />
            </FilterOffCanvas>
        </>
    );
};

export default ShortOffCanvasButton;